import React from 'react';

import profilePicture from '../../profile.png';
import Section from '../common/Section';
import './AboutMe.css';

export default function AboutMe() {
  return (
    <Section title="[ ME ]" contentClassName="about-me-content">
      <div className="image-container">
        <img src={profilePicture} className="picture" alt="Profile"/>
      </div>
      <div className="paragraph social-links">
        <a href="mailto:i@mutantbutton2.com" title="Email">[ email ]</a>
        <a href="https://github.com/mutantbutton2" title="GitHub">[ github ]</a>
      </div>
      <div className="paragraph">
        A software engineer who prefers people to know me through my work.
      </div>
      <div className="paragraph">
        I like making things, mostly virtual or food.
      </div>
    </Section>
  );
}
